import React, { useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  Box,
  IconButton,
  Collapse,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import Cancel from '@mui/icons-material/Cancel';
import CampaignIcon from '@mui/icons-material/Campaign';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getRelativeTime } from 'src/utilities/DateUtilities';

const AlertListItem = ({ alert, clickHandler, actionsComponent, isArchiving, isLatest }) => {
  const [isExpanded, setIsExpanded] = useState(isLatest);
  const ActionsComponent = actionsComponent;
  const alertTypes = {
    Failure: <Cancel sx={{ color: 'error.main' }} />,
    Success: <CheckCircleIcon sx={{ color: 'success.main' }} />,
    Announcement: <CampaignIcon sx={{ color: 'info.light' }} />,
    Warning: <InfoIcon sx={{ color: 'warning.main' }} />,
  };

  return (
    <ListItem
      disablePadding
      sx={{
        flexDirection: 'column',
        alignItems: 'stretch',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        mb: 1,
      }}
    >
      <ListItemButton onClick={() => setIsExpanded(!isExpanded)} sx={{ pr: 1 }}>
        <ListItemIcon sx={{ minWidth: 40 }}>
          {alertTypes[alert.type] ?? <InfoIcon sx={{ color: 'text.secondary' }} />}
        </ListItemIcon>
        <ListItemText
          primary={alert.title}
          slotProps={{
            primary: {
              variant: 'body2',
              fontWeight: 600,
            },
          }}
        />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1 }}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            size="small"
            sx={{
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
            }}
          >
            <ExpandMoreIcon fontSize="small" />
          </IconButton>
          <Box onClick={(e) => e.stopPropagation()}>
            <ActionsComponent alert={alert} clickHandler={clickHandler} isArchiving={isArchiving} />
          </Box>
        </Box>
      </ListItemButton>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Box sx={{ px: 2, pb: 2, pt: 0 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Box
              component="div"
              dangerouslySetInnerHTML={{ __html: alert.message }}
              sx={{
                fontSize: '0.875rem',
                lineHeight: 1.4,
                color: 'text.secondary',
                '& p': { margin: 0 },
                '& a': { color: 'primary.main', textDecoration: 'underline' },
              }}
            />
            <Tooltip title={new Date(alert.createdOn).toLocaleString()} placement="bottom-start">
              <Typography
                component="span"
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  cursor: 'default',
                  display: 'inline-block',
                }}
              >
                {getRelativeTime(alert.createdOn)}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
      </Collapse>
    </ListItem>
  );
};

export default AlertListItem;
